import IconArrowRightLarge from '@picsart/icons/IconArrowRightLarge';

import { SingleToolAppIcon } from '../../common/SingleToolAppIcon';

import useStyles from './styles';
import IToolsByCategoryProps from './types';

export default function OtherToolsByCategory({
  items,
  title,
  label,
  className,
  onCategorySelect,
}: IToolsByCategoryProps) {
  const classes = useStyles();

  return (
    <div className={className}>
      {label && <h3 className={classes.label}>{label}</h3>}
      {title && <h2 className={classes.title}>{title}</h2>}
      <ul className={classes.list}>
        {items.map((item, i) => (
          <li key={item.name + i}>
            <a
              className={classes.link}
              href={item.href}
              onClick={() => onCategorySelect(item.value)}
              target="_blank"
              rel="noreferrer"
            >
              <SingleToolAppIcon size="large" icon={{ ...item.icon, height: 48, width: 40 }} />

              <div className={classes.textContainer}>
                <div className={classes.name}>{item.name}</div>
                <div className={classes.description}>
                  <span>{item.toolsCount} tools </span>
                  <IconArrowRightLarge className={classes.icon} />
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
